<template>
  <div>
    <div style="text-align: center; width: 100%">
      <va-button class="my-1" gradient @click="adicionarContato()">
        Adicionar
      </va-button>
      <va-modal
        v-model="showModalAdd"
        hide-default-actions="true"
        size="large"
        blur
        fixed-layout
      >
        <template #header>
          <h2>Novo Contato</h2>
        </template>
        <template #default>
          <monta-form v-if="loaded" :form="formContato" @close="showModalAdd = null" @complete="(data) => addNewItem(data)"></monta-form>
        </template>
      </va-modal>
      <va-button class="my-2" color="success" gradient @click="salvarContatos(this)">
        Salvar Contatos
      </va-button>
    </div>
    <va-data-table
      :no-data-html="'Sem contatos cadastrados'"
      :items="table.items"
      :columns="table.columnsSelecteds"
      :animated="true"
      :hoverable="true"
      :striped="true"
      :per-page="table.perPage"
      :current-page="table.currentPage"
      :filter="table.filter"
      @filtered="table.filtered = $event.items"
    >
      <template #cell(cco_cargo)="{ source: cco_cargo }">
        {{ cco_cargo }}
      </template>
      <template #cell(cco_whatsapp)="{ source: cco_whatsapp }">
        {{ cco_whatsapp }}
      </template>
      <template #cell(cco_fone)="{ source: cco_fone }">
        {{ cco_fone }}
      </template>
      <template #cell(cco_email)="{ source: cco_email }">
        {{ cco_email }}
      </template>
      <template #cell(cco_notificar_financeiro)="{ source: cco_notificar_financeiro }">
        <va-icon
          v-if="cco_notificar_financeiro == 1 || cco_notificar_financeiro == true"
          name="notifications"
          size="large"
          :flip="'off'"
        />
        <va-icon
          v-else
          name="notifications_off"
          size="large"
        />
      </template>
      <template #cell(cco_notificar_chamados)="{ source: cco_notificar_chamados }">
        <va-icon
          v-if="cco_notificar_chamados == 1 || cco_notificar_chamados == true"
          name="notifications"
          size="large"
          :flip="'off'"
        />
        <va-icon
          v-else
          name="notifications_off"
          size="large"
        />
      </template>
      <template #cell(cco_obs)="{ source: cco_obs }">
        {{ cco_obs }}
      </template>
      <template #cell(cco_actions)="{ source: cco_actions, rowIndex }">
        <va-button flat icon="edit" @click="openModalToEditItemById(cco_actions, rowIndex)" />
        <va-modal
          v-model="editedItem"
          message="Editar contato"
          hide-default-actions="true"
          size="large"
          blur
          fixed-layout
        >
          <monta-form v-if="loaded" :form="formContato" @close="editedItem = null"  @complete="(data) => editItem(data)"></monta-form>
        </va-modal>
        <va-button flat icon="delete" color="danger" gradient @click="deleteItemById(rowIndex)" />
      </template>
    </va-data-table>
    <div class="row justify--center">
      <div class="flex xs2 sm2 md2 lg2 xl2">
        <va-select
          type="number"
          placeholder="Itens"
          label="Itens"
          v-model.number="table.perPage"
          :options="[10, 20, 30, 50, 100, 200, 500]"
        />
      </div>
      <div class="flex">
        <va-pagination
          v-model="table.currentPage"
          input
          :pages="pages"
        />
      </div>
      <div class="flex">
        <va-button class="my-1" @click="showModalPersonalizar = !showModalPersonalizar">
          Personalizar
        </va-button>
      </div>
    </div>
    <va-modal
      v-model="showModalPersonalizar"
      size="large"
      blur
      fixed-layout
      v-on:ok="()=>salvaEstrutura(this)"
    >
      <template #header>
        <h2>Personalizar</h2>
      </template>
      <template #default>
        <div class="row justify--center">
          <div class="flex" :key="col.key" v-for="col in table.columns.map((c) =>{return {key: c.key,label: c.label }})">
            <va-checkbox class="mt-4" v-model="table.columnsSelectedsKeys[col.key]" :label="col.label" />
          </div>
        </div>
      </template>
    </va-modal>

  </div>
</template>

<script>
import {
  refresh,
  loadDataFromStorage,
  reloadColumns,
  salvaEstrutura,
  salvarContatos,
  resetForm, loadContato, assertContactsList
} from "./EditarContatosFunctions";
import EditarContatosTable from './EditarContatosTable'
import EditarContatosFormStruct from './EditarContatosFormStruct'
import MontaForm from "@/components/monta-form/MontaForm";

export default {
  name: "EditarContatos",
  props:['idCliente'],
  components: { MontaForm },
  async mounted() {
    loadDataFromStorage(this);
    reloadColumns(this)
    await refresh(this)
  },
  data(){
    return{
      table: EditarContatosTable,
      showModalPersonalizar: false,
      showModalAdd: false,
      formContato: EditarContatosFormStruct,
      editedItemId: null,
      editedItem: null,
      id: this.idCliente,
      loaded: true
    }
  },
  computed: {
    pages() {
      return (this.table.perPage && this.table.perPage !== 0)
          ? Math.ceil(this.table.filtered.length / this.table.perPage)
          : this.table.filtered.length
    },
  },
  methods:{
    refresh,
    salvaEstrutura,
    salvarContatos,
    resetForm,
    assertContactsList,
    adicionarContato(){
      this.resetForm(this)
      this.formContato.struct[0][5].value = false
      this.formContato.struct[0][6].value = false
      this.showModalAdd = !this.showModalAdd
    },
    deleteItemById(id) {
      this.table.items = [
        ...this.table.items.slice(0, id),
        ...this.table.items.slice(id + 1),
      ]
    },
    addNewItem (data) {
      if (data.cco_notificar_chamados) {
        data.cco_notificar_chamados = 1
      } else {
        data.cco_notificar_chamados = 0
      }

      if (data.cco_notificar_financeiro) {
        data.cco_notificar_financeiro = 1
      } else {
        data.cco_notificar_financeiro = 0
      }
      this.table.items = this.assertContactsList([...this.table.items, { ...data}])
      this.showModalAdd = false
    },
    editItem (data) {
      this.table.items = this.assertContactsList([
        ...this.table.items.slice(0, this.editedItemId),
        { ...data },
        ...this.table.items.slice(this.editedItemId + 1),
      ])
      this.resetEditedItem()
    },
    openModalToEditItemById (id, rowIndex) {
      this.editedItemId = rowIndex
      this.editedItem = { ...this.table.items[rowIndex] }
      loadContato(this, id)
    },
    resetEditedItem () {
      this.editedItem = null
      this.editedItemId = null
    }
  },
  watch: {
    'table.perPage'(){
      if (window.localStorage) {
        localStorage.setItem('numLines', this.table.perPage.toString())
      }
    }
  }
}
</script>

<style scoped>

</style>